import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import * as supervisorActions from '../redux/supervisor_time_off_actions';
import * as actions from '../redux/time_off_actions';
import {LeftRequestItem, RightRequestItem, ApprovalButton} from '../TimeOff/TimeOffDetail'

export class SupervisorTimeOffRequestModal extends Component{

    constructor(props){
        super(props)
        this.state = {
            showModal: false,
            timeOffRequest: {},
            isRefreshNeeded: false,
            status: props.status,
            isDisabled: false,
            submitError: null
        }
        this.cancelClicked = this.cancelClicked.bind(this)
        this.approveClicked = this.approveClicked.bind(this)
    }

    componentWillReceiveProps(nextProps){
        if(this.props.showModal !== nextProps.showModal){
            this.setState({
                showModal: nextProps.showModal
            })
        }
        if(this.props.timeOffRequest !== nextProps.timeOffRequest){
            this.setState({
                timeOffRequest: nextProps.timeOffRequest
            })
        }

        if(nextProps.patchTimeOffResponse 
            && this.state.isRefreshNeeded
           ){
            if( !nextProps.patchTimeOffResponse.error){
                var requestParameters = {
                    Page: 1,
                    PageSize: 9999,
                    SortOrder: 'desc',
                    SortColumn: 'DateCreated',
                    customFilters: [
                        { "PropertyName": "ManagementUnitID", "Operation": 1, "Value": nextProps.managementUnitID },
                        { "PropertyName": "RequestStatus", "Operation": 1, "Value": nextProps.timeOffRequest.requestStatus }
                    ]
                }
                this.props.actions.fetchCurrentRequestsAction(requestParameters);
                this.setState({
                    isRefreshNeeded: false
                })
                this.props.toggleModal()            
            }
            else{
                this.this.setState({
                    isDisabled: true,
                    submitError: nextProps.patchTimeOffResponse.responseText
                })

            }
        }
        if(this.props.status !== nextProps.status)
            this.setState({
                status: nextProps.status
            })
    }
    toggleModal(){        
        if(this.props.toggleModal)
            this.props.toggleModal();
    }

    cancelClicked(){
        this.setState({
            isDisabled: false,
            submitError: null
        })
        this.props.toggleModal()
    }

    approveClicked(id){  
        var timeOffRequest = {}    
        if(this.state.status === "Approved")
            timeOffRequest = {
                timeoffRequestId: id,
                requestStatus: 2, //Denied
                supervisorId: this.props.User.userID                 
            }      

        else
            timeOffRequest = {
                timeoffRequestId: id,
                requestStatus: 1, //Approved
                supervisorId: this.props.User.userID
            }      
        

        if(this.props.actions.patchTimeOffRequestAction){
            this.props.actions.patchTimeOffRequestAction(timeOffRequest)                
            this.setState({isRefreshNeeded: true})
        }
    }

    render(){
        var modalStyle = {                       
            width: '775px'      
        };
        let item = this.state.timeOffRequest   
        let isDisabled = this.state.isDisabled
        let errMessage = this.state.submitError
        var overlayStyle = { zIndex: 9}     
        return(
            item !== null ?
            <ReactModal
                isOpen={this.state.showModal}              
                style={{
                    content:modalStyle,
                    overlay: overlayStyle
                 }}                 
                className='time_off_modal'> 
                <div className="modal_header">
                        Agent Time Off Request - Edit
                </div>
                <div className="modal_body">

                    <div key={0} className="request-container">                            
                        <LeftRequestItem item={item} />
                        <RightRequestItem 
                            item={item}                            
                            isModal={true}
                            status={this.state.status} />
                        <div className="error_container left">
                            {errMessage}
                        </div>
                        <ApprovalButton 
                            requestID={item !== null ? item.id : 0} 
                            onClick={this.approveClicked}
                            denyClicked={this.cancelClicked} 
                            isCancel={true}
                            currentTab={this.state.status}
                            isDisabled={isDisabled}/>                 
                    </div>
                </div>
            </ReactModal>
            : ''
        )
    }
}

function mapStateToProps(state) {
    return {
        User: state.common.user,        		        
        patchTimeOffResponse: state.timeoff.patchTimeOffResponse
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...supervisorActions, ...actions }, dispatch)
	};
}

export default connect(
    mapStateToProps,
	mapDispatchToProps
)(SupervisorTimeOffRequestModal);


// WEBPACK FOOTER //
// ./src/features/timeoff/Modals/SupervisorTimeOffRequestModal.js